import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "react-bootstrap";
import SelectDropdown from "../../../components-react/SelectDropdown";
import {
  months,
  pt_plan_status,
  susbscriptionStatus,
  years,
} from "../../../common-data/DropdowData";
import { selectGymData } from "../../../../redux/reducers/gymDataSlice";
import { fetchPTTrainersData } from "../../../../redux/reducers/apiSlice";
import { fetchGymData } from "../../../../data/APIs";

const FiltersTrainerDetails = (props) => {
  const dispatch = useDispatch();

  const {
    decryptedText,
    name,
    filters,
    setFilters,
    searchFilterApplied,
    handleKeyPress,
    onClickSearch,
    onClickReset,
    clickedCard,
  } = props || {};

  const isAdmin = decryptedText?.account_type === "admin";

  const iniAllowedFilters = {
    isSearchShow: false,
    isGymShow: false,
    isMonthFilterShow: false,
    isYearFilterShow: false,
    isTrainerShow: false,
    isPTPlanStatusShow: false,
    isRegularPlanStatusShow: false,
  };
  const [allowedFilters, setAllowedFilters] = useState(iniAllowedFilters);

  const gymData = useSelector(selectGymData);
  const { allPTTrainersData } = useSelector((state) => state.api);
  const [trainersData, setAllTrainersData] = useState([]);

  useEffect(() => {
    if (name === "pt-details-info") {
      setAllowedFilters((prevs) => ({
        ...prevs,
        isSearchShow: true,
        isMonthFilterShow:
          clickedCard !== "pt_business_lost" && clickedCard !== "all"
            ? true
            : false,
        isYearFilterShow:
          clickedCard !== "pt_business_lost" && clickedCard !== "all"
            ? true
            : false,
        isPTPlanStatusShow: true,
        isRegularPlanStatusShow: true,
      }));
    } else if (name === "trainer-details-admin") {
      setAllowedFilters((prevs) => ({
        ...prevs,
        isGymShow: isAdmin ? true : false,
        isTrainerShow: true,
      }));
    }
  }, []);

  useEffect(() => {
    if (allowedFilters.isTrainerShow) {
      dispatch(
        fetchPTTrainersData({
          gymId: filters.selectedGym?.value ? filters.selectedGym.value : "",
          token: decryptedText?.token,
        })
      );
    }
  }, [allowedFilters.isTrainerShow]);

  useEffect(() => {
    if (allowedFilters.isGymShow) {
      dispatch(fetchGymData(decryptedText?.token));
    }
  }, [allowedFilters.isGymShow]);

  useEffect(() => {
    if (allPTTrainersData?.status && allPTTrainersData?.data?.length > 0) {
      const trainers = allPTTrainersData.data?.map((item) => ({
        value: item.user_id,
        label: item.name,
      }));
      setAllTrainersData(trainers);
    } else {
      setAllTrainersData([]);
    }
  }, [allPTTrainersData]);

  return (
    <>
      <div
        className={`cmnFilterStructureContainer ptTrackContainer`}
        style={{ marginTop: "1rem" }}
      >
        <div className="filterblock gridSpanTwo">
          <div className="filterHeadingNBtn">
            <h5 className="filterHeading">All Filters</h5>
            <Button variant="outline-danger" onClick={onClickReset}>
              Reset Filter
            </Button>
          </div>

          <div className="filtersDropdown fourtGrid">
            {allowedFilters.isSearchShow && (
              <div
                className={`inputCommonWrapper flexSpacebetween searchBarContainer span2 ${
                  searchFilterApplied ? "redBorderRedText" : ""
                }`}
                style={{
                  height: "50px",
                }}
              >
                <input
                  type="search"
                  className="input"
                  placeholder="Search..."
                  value={filters?.searchString}
                  onChange={(e) =>
                    setFilters({
                      ...filters,
                      searchString: e.target.value,
                    })
                  }
                  onKeyDown={handleKeyPress}
                />
                <button
                  type="button"
                  className="button"
                  onClick={onClickSearch}
                >
                  search
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-search"
                    viewBox="0 0 16 16"
                  >
                    <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0" />
                  </svg>
                </button>
              </div>
            )}

            {allowedFilters.isGymShow && (
              <div
                className={`commonWrapper dropdownCommonWrapper ${
                  filters?.selectedGym?.value ? "redBorderRedText" : ""
                }`}
              >
                <SelectDropdown
                  options={gymData}
                  selectedOption={filters?.selectedGym}
                  setSelectedOption={(selectedValue) =>
                    setFilters({
                      ...filters,
                      selectedGym: selectedValue,
                    })
                  }
                  name="Gym"
                />
              </div>
            )}

            {allowedFilters.isTrainerShow && (
              <div
                className={`commonWrapper dropdownCommonWrapper ${
                  filters?.selectedTrainer?.value ? "redBorderRedText" : ""
                }`}
              >
                <SelectDropdown
                  options={trainersData}
                  selectedOption={filters?.selectedTrainer}
                  setSelectedOption={(selectedValue) =>
                    setFilters({
                      ...filters,
                      selectedTrainer: selectedValue,
                    })
                  }
                  name="Trainer"
                />
              </div>
            )}

            {allowedFilters.isMonthFilterShow && (
              <div
                className={`commonWrapper dropdownCommonWrapper ${
                  filters?.selectedMonth?.value ? "redBorderRedText" : ""
                }`}
              >
                <SelectDropdown
                  options={months}
                  selectedOption={filters?.selectedMonth}
                  setSelectedOption={(selectedValue) =>
                    setFilters({
                      ...filters,
                      selectedMonth: selectedValue,
                    })
                  }
                  name="Month"
                />
              </div>
            )}

            {allowedFilters.isYearFilterShow && (
              <div
                className={`commonWrapper dropdownCommonWrapper ${
                  filters?.selectedYear?.value ? "redBorderRedText" : ""
                }`}
              >
                <SelectDropdown
                  options={years}
                  selectedOption={filters?.selectedYear}
                  setSelectedOption={(selectedValue) =>
                    setFilters({
                      ...filters,
                      selectedYear: selectedValue,
                    })
                  }
                  name="Year"
                />
              </div>
            )}

            {allowedFilters.isRegularPlanStatusShow && (
              <div className="commonWrapperWithLabel">
                <div
                  className={`commonWrapper dropdownCommonWrapper ${
                    filters?.selRegularPlanStatus?.value
                      ? "redBorderRedText"
                      : ""
                  }`}
                >
                  <SelectDropdown
                    options={susbscriptionStatus}
                    selectedOption={filters?.selRegularPlanStatus}
                    setSelectedOption={(selectedValue) =>
                      setFilters({
                        ...filters,
                        selRegularPlanStatus: selectedValue,
                      })
                    }
                    name="Regular Plan Status"
                  />
                </div>
              </div>
            )}

            {allowedFilters.isPTPlanStatusShow && (
              <div
                className={`commonWrapper dropdownCommonWrapper ${
                  filters?.selPTPlanStatus?.value ? "redBorderRedText" : ""
                }`}
              >
                <SelectDropdown
                  options={pt_plan_status}
                  selectedOption={filters?.selPTPlanStatus}
                  setSelectedOption={(selectedValue) =>
                    setFilters({
                      ...filters,
                      selPTPlanStatus: selectedValue,
                    })
                  }
                  name="PT Plan Status"
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default FiltersTrainerDetails;
